// eslint-disable-next-line jsx-a11y/href-no-hash
import $http from '../api/index'

const requestSignature = (url, cb) => {
  $http.getSignature({url}).then(res => {
    const {noncestr, timestamp, signature} = res;
    cb(noncestr, signature, timestamp);
  })
};

/* eslint-disable no-undef */

const wx = require('weixin-js-sdk');

export const weixinShare = model => {
  if (!model) return;

  if (typeof wx === 'undefined') return;
  const weixin = {
    link: model.link || window.location.href,
    image: model.image,
    title: model.title, // title和brief位置互换
    descr: model.descr,
  };

  const cb = (nonceStr, signature, timestamp) => {
    const v = {
      appId: 'wx3eec6b8c74a8a130',
      nonceStr: nonceStr,
      signature: signature,
      timestamp: timestamp,
    };

    wx.config({
      debug: false,
      appId: v.appId,
      timestamp: v.timestamp,
      nonceStr: v.nonceStr,
      signature: v.signature,
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'updateAppMessageShareData',
        'updateTimelineShareData',
      ]
    });

    wx.ready(function() {
      console.log('ready');
      // 分享到朋友圈
      // onMenuShareTimeline
      if (wx.onMenuShareTimeline) {
        wx.onMenuShareTimeline({
          title: weixin.title, // 分享标题
          desc: weixin.descr, // 分享描述
          link: weixin.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: weixin.image, // 分享图标
          success: function() {
            console.log('设置成功')
          },
          fail(e) {
            console.log(e)
          },
          complete(e) {
            console.log(e);
          }
        });
      } else {
        // “分享给朋友”及“分享到QQ”按钮的分享内容（1.4.0）
        wx.updateAppMessageShareData({
          title: weixin.title, // 分享标题
          desc: weixin.descr, // 分享描述
          link: weixin.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: weixin.image, // 分享图标
          success: function() {
            console.log('设置成功')
            // 设置成功
          },
          fail(e) {
            console.log(e)
          },
          complete(e) {
            console.log(e);
          }
        });
      }

      // 分享给朋友
      // onMenuShareAppMessage
      if (wx.onMenuShareAppMessage) {
        wx.onMenuShareAppMessage({
          title: weixin.title,
          link: weixin.link,
          imgUrl: weixin.image,
          desc: weixin.descr,
          success: function() {
            // 设置成功
            console.log('设置成功')
          },
          fail(e) {
            console.log(e)
          },
          complete(e) {
            console.log(e)
          }
        });
      } else {
        wx.updateTimelineShareData({
          title: weixin.title,
          link: weixin.link,
          imgUrl: weixin.image,
          desc: weixin.descr,
          success: function() {
            // 设置成功
            console.log('设置成功')
          },
          fail(e) {
            console.log(e)
          },
          complete(e) {
            console.log(e)
          }
        });
      }
    });
  };

  requestSignature(model.link, cb);
};
